import D2C_ServiceApp from './App'

class D2C_ServicePHPApache extends D2C_ServiceApp {
  static objectType = 'serviceType'
  static active = true
  static order = 11
  static typeName = 'phpApache'
  static typeTitle = 'PHP + Apache'
  static color = '#7777cc'
  static methods = {
    ...D2C_ServiceApp.methods,
    scale: true,
  }
  static fields = {
    ...D2C_ServiceApp.fields,
    configs: {
      ...D2C_ServiceApp.fields.configs,
      default: [
        {name: 'php.ini', text: require('raw-loader!@/assets/configs/phpApache-php.ini').default, custom: false},
        {name: 'vhost.conf', text: require('raw-loader!@/assets/configs/phpApache-vhost.conf').default, custom: false},
      ],
    },
    extensions: {
      default: ['mysqli', 'opcache'],
      enum: ['bcmath', 'bz2', 'calendar', 'dba', 'enchant', 'exif', 'gd', 'gettext', 'gmp', 'imap', 'interbase', 'intl', 'ldap', 'mysqli', 'opcache', 'pcntl', 'pdo_dblib', 'pdo_firebird', 'pdo_mysql', 'pdo_odbc', 'pdo_pgsql', 'pgsql', 'pspell', 'recode', 'shmop', 'snmp', 'soap', 'sockets', 'sysvmsg', 'sysvsem', 'sysvshm', 'tidy', 'wddx', 'xmlrpc', 'xsl', 'zip'],
      label: 'PHP extensions',
      multiple: true,
      path: 'extensions',
      required: false,
      validate() {
        return null
      },
      creating: {},
      updating: {},
      importing: {
        hidden: true,
      },
    },
    hosts: {
      ...D2C_ServiceApp.fields.hosts,
      selector: {
        default: ['node', 'node'],
      },
    },
    image: {
      ...D2C_ServiceApp.fields.image,
      default: 'd2cio/php',
    },
    peclPackages: {
      allowAdditions: true,
      default: [],
      enum: ['amqp', 'apcu', 'ast', 'ds', 'event', 'geoip', 'grpc', 'igbinary', 'imagick', 'mcrypt', 'memcached', 'mongodb', 'oauth', 'rdkafka', 'redis', 'uuid', 'xdebug', 'yaml'],
      label: 'PECL Packages',
      multiple: true,
      path: 'peclPackages',
      placeholder: 'Enter a package name and press Enter',
      required: false,
      validate(value) {
        const invalidNames = value.filter(peclPackage => !peclPackage.match(/^[a-zA-Z0-9_.-]{2,32}$/))
        if (invalidNames.length) {
          return 'Invalid PECL package names: ' + invalidNames.join(', ')
        }
        return null
      },
      creating: {},
      updating: {},
      importing: {
        hidden: true,
      },
    },
    ports: {
      ...D2C_ServiceApp.fields.ports,
      default: [
        {protocol: 'TCP', value: 80},
      ],
    },
    source: {
      ...D2C_ServiceApp.fields.source,
      example: 'https://github.com/d2cio/phpApache-hello-world',
    },
    version: {
      ...D2C_ServiceApp.fields.version,
      default: '7.4',
      enum: ['7.1', '7.2', '7.3', '7.4'],
    },
    volumes: {
      ...D2C_ServiceApp.fields.volumes,
      demo: [
        {src: '/ebs/containers/$serviceName/sources', dst: '/var/www/$serviceName', sync: false},
      ],
    },
  }
}

export default D2C_ServicePHPApache
